import { render, staticRenderFns } from "./PvcListItem.vue?vue&type=template&id=88eb6d00&"
import script from "./PvcListItem.vue?vue&type=script&lang=js&"
export * from "./PvcListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports